const DescriptionSmall = ({ description }) => {
  return (
    <small className="block text-[#A1A1A1] mt-0 md:normal lg:normal">
      {description}
    </small>
  );
}

export default DescriptionSmall;